<template>
	<div class="EventList">
		<el-card class="box-card">
			<div class="flex justify-between">
				<p class="title">Events & Promotions</p>
				<!-- <i
					class="el-icon-close cursor-pointer text-2xl mr-2"
					@click="closeEventsPageDialog()"
				></i> -->
				<div class="text-right" style="padding-right: 7px;">
					<el-button
						type="warning"
						size="small"
						icon="el-icon-plus"
						style="min-width: 100px;height:37px; background: #e29d5a;"
						@click="onAddEvent"
						>Add</el-button
					>
				</div>
			</div>
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="9" :lg="9" :xl="9">
					<!-- <p class="text-xs font-bold">Location</p> -->
					<base-locations-dropdown class="mdms" @selectedLocationVal="dropdown" />
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
					<p class="text-xs font-bold">From</p>
					<el-date-picker
						v-model="fromDate"
						type="date"
						style="width:100%;"
						placeholder="From Date"
						:picker-options="{firstDayOfWeek: 1}"
						@change="changedDate"
					>
					</el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
					<p class="text-xs font-bold">To</p>
					<el-date-picker
						v-model="toDate"
						type="date"
						style="width:100%;"
						placeholder="To Date"
						:picker-options="disabledStartDate"
						@change="changedDate"
					>
					</el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="3" :lg="3" :xl="3">
					<div class="text-right">
						<!-- <label>&nbsp;</label> -->
						<!-- <BaseButton
							type="text"
							style="height: 37px; max-width: 100px;"
							buttonclass="btn p-2 text-sm font-extrabold"
							@click="onGoClick()"
							>Go</BaseButton
						> -->
						<el-button
							type="warning"
							size="small"
							style="min-width: 100px;height:40px; margin-top: 10px; background: #e29d5a;"
							@click="onGoClick()"
							>Go</el-button
						>
					</div>
				</el-col>
				<!-- <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5">
					<label>&nbsp;</label>
					<div class="text-right">
						<el-button
							type="warning"
							size="small"
							icon="el-icon-plus"
							style="min-width: 120px;height:37px; background: #e29d5a;"
							@click="onAddEvent"
							>Add</el-button
						>
					</div>
				</el-col> -->
			</el-row>
		</el-card>

		<el-card class="box-card mt-2">
			<div class="mt-4 mb-2 text-right">
				<!-- <span class="text-sm text-grey-dark"
					>india <i class="el-icon-arrow-right"></i
				></span> -->
				<!-- <a class="cursor-pointer" @click="downloadCsvReport('CSV')">
					<img
						src="../../../../assets/images/download.png"
						alt=""
						style="vertical-align: middle;"
					/>
					Export to .csv
				</a> -->
				<el-button size="mini" type="primary" plain>CSV <i class="el-icon-download" @click="downloadCsvReport('CSV')"></i></el-button>
			</div>

			<div class="event-table">
				<table>
					<thead>
						<tr>
							<th>
								Date
								<span>
									<i v-if="sort_by_ascending_date" class="el-icon-caret-top text-base cursor-pointer" @click="sortByDescendingDate()"></i>

									<i v-if="sort_by_descending_date" class="el-icon-caret-bottom text-base cursor-pointer" @click="sortByAscendingDate()"></i>
								</span>
							</th>
							<th>Location</th>
							<th>Event</th>
							<th>
								Event Type

								<el-popover
									placement="bottom"
									width="100"
									trigger="click">

									<div>
										<div>
											<el-checkbox v-model="external_events" class="checkbox-lable">External</el-checkbox>
										</div>
										<div class="mt-2">
											<el-checkbox v-model="internal_events" class="checkbox-lable">Internal</el-checkbox>
										</div>
										<div class="flex justify-between mt-4">
											<span class="text-xs cursor-pointer primary-theme-color" @click="selectAllEventTypeFilters()">Select all</span>
											<span class="text-xs cursor-pointer" @click="resetEventTypeFilters()">Reset</span>
										</div>
									</div>

									<span slot="reference">
										<i class="el-icon-caret-bottom"></i>
										<!-- &nbsp;
										<img src="../../../../assets/images/filter.png" width="12" class="align-sub cursor-pointer"> -->
									</span>
								</el-popover>
							</th>
							<th>
								Category

								<el-popover
									placement="bottom"
									trigger="click">

									<div>
										<el-checkbox-group v-model="selected_categories">
											<el-checkbox v-for="(cat, category_index) in all_event_category_list" :key="category_index" class="mb-2 checkbox-lable" :label="cat.title" style="display: block;"></el-checkbox>
										</el-checkbox-group>

										<div class="flex justify-between mt-4">
											<span class="text-xs cursor-pointer primary-theme-color" @click="selectAllEventCategories()">Select all</span>
											<span class="text-xs cursor-pointer" @click="resetSelectedEventCategories()">Reset</span>
										</div>
									</div>

									<span slot="reference">
										<i class="el-icon-caret-bottom"></i>
									<!-- &nbsp;
										<img src="../../../../assets/images/filter.png" width="12" class="align-sub cursor-pointer"> -->
									</span>
								</el-popover>
							</th>
							<th>Created by</th>
							<!-- <th>Sales Impact(%)</th> -->
							<th style="width: 8%;"></th>
						</tr>
					</thead>

					<tbody v-if="getEventsList.length">
						<tr v-for="(event, eventIndex) in getEventsList" :key="eventIndex">
							<td>
								<p class="text-center" v-if="event.start_date == event.end_date"> {{event.end_date | date_filter}}</p>
								<p class="text-center" v-else>{{ event.start_date | date_filter}} To {{ event.end_date |date_filter}}</p>
							</td>
							<td>
								<div v-if="event.stores.length <= 2">
									<span class="py-1 capitalize text-center " v-for="(store, StIndex) in event.stores" :key="StIndex">
										{{store.name}} {{StIndex != event.stores.length -1  ? "," : ""}}
									</span>
								</div>
								<div v-if="event.stores.length > 2">
									<el-popover
										placement="top-start"
										trigger="hover"
									>
										<p class="py-1 capitalize text-left " v-for="(store, StIndex) in event.stores" :key="StIndex">
											{{store.name}}
										</p>
										<p slot="reference" class="cursor-pointer capitalize">
											<span>
												{{event.stores[0].name}}bvc
											</span>
											,
											<span>
												{{event.stores[1].name}}
											</span>
											<span class="font-bold">
												+{{event.stores.length - 2}}
											</span>
										</p>
									</el-popover>
								</div>
								<div v-if="event.countries.length <= 2">
									<p class="py-1 capitalize text-center " v-for="(store, StIndex) in event.countries" :key="StIndex">
										{{store.name}} {{StIndex != event.countries.length -1  ? "," : ""}}
									</p>
								</div>
								<div v-if="event.countries.length > 2">
									<el-popover
										placement="top-start"
										trigger="hover"
									>
										<span class="py-1 capitalize text-left " v-for="(store, StIndex) in event.countries" :key="StIndex">
											{{store.name}}
										</span>
										<p slot="reference" class="cursor-pointer capitalize">
											<span>
												{{event.countries[0].name}}
											</span>
											,
											<span>
												{{event.countries[1].name}}
											</span>
											<span class="font-bold">
												+{{event.countries.length - 2}}
											</span>
										</p>
									</el-popover>
								</div>
								<div v-if="event.regions.length <= 2">
									<span class="py-1 capitalize text-center " v-for="(store, StIndex) in event.regions" :key="StIndex">
										{{store.name}} {{StIndex != event.regions.length -1  ? "," : ""}}
									</span>
								</div>
								<div v-if="event.regions.length > 2">
									<el-popover
										placement="top-start"
										trigger="hover"
									>
										<p class="py-1 capitalize text-left " v-for="(store, StIndex) in event.regions" :key="StIndex">
											{{store.name}}
										</p>
										<p slot="reference" class="cursor-pointer capitalize">
											<span>
												{{event.regions[0].name}}
											</span>
											,
											<span>
												{{event.regions[1].name}}
											</span>
											<span class="font-bold">
												+{{event.regions.length - 2}}
											</span>
										</p>
									</el-popover>
								</div>
								<div v-if="event.subregions.length <= 2">
									<span class="py-1 capitalize text-center " v-for="(store, StIndex) in event.subregions" :key="StIndex">
										{{store.name}} {{StIndex != event.subregions.length -1  ? "," : ""}}
									</span>
								</div>
								<div v-if="event.subregions.length > 2">
									<el-popover
										placement="top-start"
										trigger="hover"
									>
										<p class="py-1 capitalize text-left " v-for="(store, StIndex) in event.subregions" :key="StIndex">
											{{store.name}}
										</p>
										<p slot="reference" class="cursor-pointer capitalize">
											<span>
												{{event.subregions[0].name}}
											</span>
											,
											<span>
												{{event.subregions[1].name}}
											</span>
											<span class="font-bold">
												+{{event.subregions.length - 2}}
											</span>
										</p>
									</el-popover>
								</div>
								<!-- <el-popover
									placement="top-start"
									width="200"
									trigger="hover"
								>
									<p class="py-1 capitalize text-center " v-for="(store, StIndex) in event.stores" v-if="event.stores.length" :key="StIndex">
									{{store.name}}
									</p>
									<p class="py-1 capitalize text-center " v-for="(country, CIndex) in event.countries" v-if="event.countries.length" :key="CIndex">
										{{country.name}}
									</p>
									<p class="py-1 capitalize text-center " v-for="(region, RIndex) in event.regions" v-if="event.regions.length" :key="RIndex">
										{{region.name}}
									</p>
									<p class="py-1 capitalize text-center " v-for="(subregion, SRIndex) in event.subregions" v-if="event.subregions.length" :key="SRIndex">
										{{subregion.name}}
									</p>
									<p slot="reference" class="cursor-pointer capitalize">
										{{ event.stores.length
										? event.stores[0].name
										: event.countries.length
										? event.countries[0].name
										: event.regions.length
										? event.regions[0].name
										: event.subregions.length
										? event.subregions[0].name
										: "" }}
										{{ event.stores.length > 1
										? "+"
										: event.countries.length > 1
										? "+"
										: event.regions.length > 1
										? "+"
										: event.subregions.length > 1
										? "+"
										: "" }}
									</p>
								</el-popover> -->
								<!-- {{
									event.stores.length
										? event.stores[0].name
										: event.countries.length
										? event.countries[0].name
										: event.regions.length
										? event.regions[0].name
										: event.subregions.length
										? event.subregions[0].name
										: ""
								}} -->

							</td>
							<td>{{ event.name }}</td>
							<td>{{ event.event_type }}</td>
							<td>{{ event.category_name }}</td>
							<!-- <td><a href="#">{{event.event_type === 'Internal' ? 'View Details' : ''}}</a></td> -->
							<!-- <td>{{event.impact_sales}}</td> -->
							<td>
								<div>{{ event.created_by_first_name }} {{ event.created_by_last_name }}</div>
								<div class="mt-1" style="color: #999; font-size: 0.7rem;">Created on {{ moment(event.created_on).format('YYYY/MM/DD HH:mm') }}</div>
							</td>
							<td style="width: 8%;">
								<img
									src="../../../../assets/images/edit.png"
									width="18"
									class="mr-2"
									alt=""
									@click="editEvent(event)"
								/>
								<img
									src="../../../../assets/images/delete-icon.png"
									width="18"
									alt=""
									@click="onDeleteEvent('yes', event)"
								/>
							</td>
						</tr>
					</tbody>
				</table>

				<div v-if="!getEventsList.length" class="text-center primary-theme-color text-sm font-semibold" style="padding: 15px;">
					No data available
				</div>
			</div>
		</el-card>
		<!-- <div class="text-right mt-4">
			<el-pagination
				background
				:current-page.sync="pageInfo.currentPage"
				:page-sizes="[5, 10, 15]"
				:page-size.sync="pageInfo.pageSize"
				layout="prev, pager, next"
				:total="pageInfo.count"
				@size-change="handlePageSizeInfoChange"
				@current-change="handlePageInfoChange"
			/>
		</div> -->
		<el-dialog
			title="Alert"
			:visible.sync="storeClosedVisible"
			width="50%"
			append-to-body
		>
			<span style="line-height: 1.5; color: #32343d;"
				>Shifts for the selected dates will be deleted, changes to Weekly offs
				will need to be done manually. <br />
				<br />
				Do you wish to continue?
			</span>
			<span slot="footer" class="dialog-footer">
				<div
					style="display: flex; justify-content: flex-end; margin-top: 10px;"
				>
					<BaseButton
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						@click="storeClosedVisible = false"
					>
						Cancel
					</BaseButton>
					<BaseButton
						v-if="id"
						type="submit"
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						style="margin: 0 10px;"
						@click="updateEvent"
					>
						Continue
					</BaseButton>
					<BaseButton
						v-else
						type="submit"
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						style="margin: 0 10px;"
						@click="addEvent"
					>
						Continue
					</BaseButton>
				</div>
			</span>
		</el-dialog>

		<el-dialog
			title="Alert"
			:visible.sync="storeNextCloseddVisible"
			width="50%"
			append-to-body
		>
			<span
				>Will this be an extra Day Off or be adjusted as a Weekly Off?
				<br />
				<br />
				<el-radio v-model="radio" :label="true">
					<h4>Day Off</h4>
					<p>
						NOTE - All the employees will be given aditional day off apart from
						Weekly Off
					</p>
				</el-radio>
				<br />
				<el-radio v-model="radio" :label="false">
					<div>
						<h4>Weekly Off</h4>
						<p>
							NOTE - All the employees will be marked weeklyoff on the selected
							<br />
							dates and balance weekly off day off will be adjusted on other
							days
						</p>
					</div>
				</el-radio>
			</span>
			<span slot="footer" class="dialog-footer">
				<div
					style="display: flex; justify-content: flex-end; margin-top: 10px;"
				>
					<BaseButton
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						@click="storeNextCloseddVisible = false"
					>
						Cancel
					</BaseButton>
					<BaseButton
						v-if="id"
						type="submit"
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						style="margin: 0 10px;"
						@click="updateEvent"
					>
						Continue
					</BaseButton>
					<BaseButton
						v-else
						type="submit"
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						style="margin: 0 10px;"
						@click="addEvent"
					>
						Continue
					</BaseButton>
				</div>
			</span>
		</el-dialog>

		<el-dialog
			:key="addEventPopupKey"
			:title="!id ? 'Add Event' : 'Update Event'"
			:visible.sync="addEventPopup"
			:before-close="closePopup"
			append-to-body
			width="60%"
		>
			<!-- <div class="flex mb-4">
				<el-button type="warning" size="small" @click="addEventPopup = false"
					>Download Template</el-button
				>
				<el-button type="warning" size="small" @click="addEventPopup = false"
					>Upload Csv</el-button
				>
			</div> -->
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">Location</p>
					<base-locations-dropdown
						:key="resetLocationDD"
						:selected-location="selectedLocation"
						class="mdms"
						@selectedLocationVal="dropdownUpdate"
					/>
					<p v-if="locError" class="text-red-dark text-xs">
						Select Location to add Event
					</p>

					<!-- <div v-else>
						<p class="text-xs mb-1">Location</p>
						<div class="font-bold capitalize">{{ location_name }}</div>
					</div> -->

					<!-- <el-cascader
						v-model="location"
						:options="options"
						:show-all-levels="false"
						:props="{ expandTrigger: 'hover'}"
						@change="handleChange">
					</el-cascader> -->
				</el-col>
			</el-row>
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
					<p class="text-xs mb-1">Event Title</p>
					<el-input
						v-model="event_title"
						v-validate="addEventPopup ? 'required' : ''"
						placeholder="Event Title"
						name="Event Title"
						style="width: 100%; height: 37px!important;"
					></el-input>
					<p>
						<span
							:v-show="errors.has('Event Title')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("Event Title") }}
						</span>
					</p>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">Event Type</p>
					<el-select
						v-model="event_type"
						v-validate="addEventPopup ? 'required' : ''"
						style="width: 100%;"
						placeholder="Select"
						name="event_type"
						@change="clearCategory"
					>
						<el-option
							v-for="item in event_type_list"
							:key="item.name"
							:label="item.name"
							:value="item.name"
						>
						</el-option>
					</el-select>
					<p>
						<span
							:v-show="errors.has('event_type')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("event_type") }}
						</span>
					</p>
				</el-col>
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">Event Category</p>
					<el-select
						v-if="event_type == 'Internal Event'"
						v-model="category"
						v-validate="
							addEventPopup && event_type == 'Internal Event' ? 'required' : ''
						"
						placeholder="Select"
						name="Internal Event Category"
						style="width: 100%;"
					>
						<el-option
							v-for="(item, index1) in internal_category"
							:key="index1"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
					<el-select
						v-else
						v-model="category"
						v-validate="
							addEventPopup && event_type == 'External Event' ? 'required' : ''
						"
						style="width: 100%;"
						placeholder="Select"
						name="External Event Category"
					>
						<el-option
							v-for="(item, index2) in external_category"
							v-if="item.id != 13"
							:key="index2"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
					<p>
						<span
							:v-show="errors.has('Internal Event Category')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("Internal Event Category") }}
						</span>
					</p>
					<p>
						<span
							:v-show="errors.has('External Event Category')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("External Event Category") }}
						</span>
					</p>
				</el-col>
			</el-row>
			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">Start Date</p>
					<el-date-picker
						v-model="start_date"
						v-validate="addEventPopup ? 'required' : ''"
						style="width: 100%;"
						type="date"
						placeholder="Start Date"
						:picker-options="{firstDayOfWeek: 1}"
						name="Start Date"
						@change="getOriginalForecast()"
					>
					</el-date-picker>
					<p>
						<span
							:v-show="errors.has('Start Date')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("Start Date") }}
						</span>
					</p>
				</el-col>
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">End Date</p>
					<el-date-picker
						v-model="end_date"
						v-validate="addEventPopup ? 'required' : ''"
						style="width: 100%;"
						type="date"
						placeholder="End Date"
						:picker-options="disabledPopupStartDate"
						name="End Date"
						@change="getOriginalForecast()"
					>
					</el-date-picker>
					<p>
						<span
							:v-show="errors.has('End Date')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("End Date") }}
						</span>
					</p>
				</el-col>
			</el-row>

			<!-- <el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">Start Time</p>
					<el-time-select
						v-model="start_time"
						style="width: 100%;"
						:picker-options="{
							start: '00:00',
							step: '00:30',
							end: '23:59'
						}"
						:disabled="category == 3"
						placeholder="Start time"
					>
					</el-time-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">End Time</p>
					<el-time-select
						v-model="end_time"
						style="width: 100%;"
						:picker-options="{
							start: '00:00',
							step: '00:30',
							end: '23:59'
						}"
						:disabled="category == 3"
						placeholder="End time"
						name="End time"
					>
					</el-time-select>
					<p>
						<span
							:v-show="errors.has('End time')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("End time") }}
						</span>
					</p>
				</el-col>
			</el-row> -->

			<el-row :gutter="10" class="p-2 flex items-center">
				<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
					<p class="py-2">Sales Impact</p>
					<div class="flex items-center">
						<el-select
							:value="sales_impact"
							style="width: 100%"
							name='Sales Impact'
							placeholder="Sales Impact"
							:filterabe="true"
							@change="changeSalesImpact(sales_impact, $event)"
						>
							<el-option
								v-for="(item, itemIndex) in sales_impact_list"
								:key="itemIndex"
								:label="item.title"
								:value="item.value"
							>
							</el-option>
						</el-select>
						<span class="ml-2 cursor-pointer"><img src="../../../../assets/images/info.png" width="18"></span>
					</div>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">Original Forecast</p>
					<div class="flex items-center">
						<el-input
							v-model="original_forecast"
							placeholder="Original Forecast"
							disabled
							style="width: 80%;"
						></el-input>
					</div>
				</el-col>

				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<p class="text-xs mb-1">Updated Forecast</p>
					<div class="flex items-center">
						<el-input
							v-model="updated_forecast"
							placeholder="Updated Forecast"
							disabled
							style="width: 80%;"
						></el-input>
					</div>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<p v-if="last_updated_by" class="text-xs font-bold mb-1">Last Updated by: <span class="capitalize">{{ last_updated_by }}</span></p>
					<p v-if="last_updated_on" class="text-xs font-bold mb-1">Last Updated on: <span>{{ last_updated_on }}</span></p>
				</el-col>
			</el-row>

			<el-row :gutter="20" class="p-2 flex items-center">
				<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
					<p class="text-xs mb-1">Description</p>
					<textarea
						v-model="description"
						class="p-2"
						style="width: 100%;height: 75px;border: 1px solid #dcdfe6;resize: none;border-radius: 4px;outline:none;"
						name=""
					></textarea>
					<!-- <el-select v-model="sales_impact" placeholder="Select">
						<el-option v-for="item in impact" :key="item" :value="item">
							{{ item }}%
						</el-option>
					</el-select> -->
				</el-col>
			</el-row>

			<span style="display: flex; align-items: center; justify-content: flex-end;" slot="footer" class="dialog-footer">
				<BaseButton
					type="submit"
					class="w-24"
					buttonclass="btn p-2 text-xs "
					@click="addEventPopup = false"
				>
					Cancel
				</BaseButton>

				<BaseButton
					v-if="update"
					v-loading="event_loading"
					type="submit"
					class="w-24 ml-2"
					buttonclass="btn p-2 text-xs "
					@click="updatecheckedStoreClosed"
				>
					Update
				</BaseButton>

				<BaseButton
					v-else
					type="submit"
					v-loading="event_loading"
					class="w-24 ml-2"
					buttonclass="btn p-2 text-xs "
					@click="checkedStoreClosed"
				>
					Add
				</BaseButton>
			</span>
		</el-dialog>

		<el-dialog
			title="Warning"
			:visible.sync="deleteDialogVisible"
			width="40%"
			left
			append-to-body
		>

			<span class="capitalize"> Are you sure to continue?</span>
			<span slot="footer" class="dialog-footer">
				<div
					style="display: flex; justify-content: flex-end; margin-top: 10px;"
				>
					<BaseButton
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						@click="onDeleteEvent('no', null)"
					>
						Cancel
					</BaseButton>
					<BaseButton
						type="submit"
						buttonclass="btn p-2 text-xs"
						class="w-24 mr-4"
						style="margin: 0 10px;"
						@click="deleteEvent()"
					>
						Delete
					</BaseButton>
				</div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import BaseLocationsDropdown from "../../../baseLocationsDD/BaseLocationsDD.vue";
import moment from "moment";
import RealTimeService from "../../../../services/realTimeService.js";
import { serverAddr } from "../../../../networkConfig";
import { EventBus } from "../../../../eventBus";
import Papa from "papaparse";
export default {
	name: "EventList",
	components: {
		BaseLocationsDropdown
	},
	filters: {
		formatDate(date) {
			if (date) {
				let d = new Date(date);
				// console.log("formatDate", moment(d).format("LLLL"));
				return moment(d).format("D MMM YYYY");
			}
		},
		date_filter(date){
			if(date){
				// return moment(date).format('DD-MM-YYYY');
				return moment(date).format("Do MMM YY");
			}
		}
	},
	props: {
		showAddPopup: {
			type: Boolean,
			default: false
		},
		eventData: {
			type: Object,
			default: () => {}
		},
		eventStartDate: {
			type: String,
			default: null
		},
		eventEndDate: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			resetLocationDD: 0,
			eventToDelete: {},
			storeClosedVisible: false,
			storeNextCloseddVisible: false,
			deleteDialogVisible: false,
			radio: true,
			description: "",
			options: [],
			addEventPopup: false,
			addEventPopupKey: 0,
			events: [],
			location: [],
			fromDate: "",
			toDate: "",
			start_date: "",
			end_date: "",
			start_time: "",
			end_time: "",
			locError: "",
			sales_impact: "0",
			category: null,
			event_type: "Internal Event",
			event_title: "",
			original_forecast: null,
			updated_forecast: null,
			last_updated_by: "",
			last_updated_on: "",
			sales_impact_list: [],
			categoryList: [],
			event_type_list: [{ name: "Internal Event" }, { name: "External Event" }],
			internal_category: [],
			external_category: [],
			impact: [
				0,
				5,
				10,
				15,
				20,
				25,
				30,
				35,
				40,
				45,
				50,
				55,
				60,
				65,
				70,
				75,
				80,
				85,
				90,
				95,
				100,
				105,
				110,
				115,
				120,
				125,
				130,
				135,
				140,
				145,
				150,
				155,
				160,
				165,
				170,
				175,
				180,
				185,
				190,
				195,
				200
			],
			country: "",
			region: "",
			event_loading: false,
			subregion: "",
			outlet: "",
			basics: "",
			countris: [],
			regions: [],
			subregions: [],
			outlets: [],
			newBasics: "",
			selectStore: "",
			selectedLocation: [],
			id: "",
			location_name: "",
			update: false,
			pageInfo: {
				currentPage: 1,
				count: null,
				pageSize: 10
			},
			filters: {
				outlets: [],
				countries: [],
				regions: [],
				subregions: []
			},
			user: {},
			disabledStartDate: {
				disabledDate: date => {
					return date < this.fromDate;
				},
				firstDayOfWeek: 1
			},
			disabledPopupStartDate: {
				disabledDate: date => {
					return date < this.start_date;
				},
				firstDayOfWeek: 1
			},
			sort_by_ascending_date: false,
			sort_by_descending_date: true,
			external_events: false,
			internal_events: false,
			all_event_category_list: [
				{
					title: 'Marketing Promotion',
					is_selected: false
				},
				{
					title: 'New Product Launch',
					is_selected: false
				},
				{
					title: 'Store Closed',
					is_selected: false
				},
				{
					title: 'Others',
					is_selected: false
				},
				{
					title: 'Festival',
					is_selected: false
				},
				{
					title: 'Movie Release',
					is_selected: false
				},
				{
					title: 'Mall Event',
					is_selected: false
				},
				{
					title: 'Live Event',
					is_selected: false
				},
				{
					title: 'Sports Event',
					is_selected: false
				},
				{
					title: 'Political strike / Protest',
					is_selected: false
				},
				{
					title: 'Voting Day',
					is_selected: false
				},
				{
					title: 'Bank Holiday',
					is_selected: false
				},
			],
			selected_categories: [],
			moment: moment
		};
	},

	computed: {
		getEventsList(){
			let event_list = this.events;

			if(this.sort_by_ascending_date && this.sort_by_descending_date){
				return event_list;
			}

			if(this.sort_by_ascending_date){
				event_list = event_list.slice().sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
			}

			if(this.sort_by_descending_date){
				event_list = event_list.slice().sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
			}

			if(this.external_events && this.internal_events){
				return event_list;
			}

			if(this.external_events){
				event_list = event_list.slice().filter((e) => e.event_type == 'External');
			}

			if(this.internal_events){
				event_list = event_list.slice().filter((e) => e.event_type == 'Internal');
			}

			if(this.selected_categories.length){
				event_list = event_list.slice().filter((e) => this.selected_categories.indexOf(e.category_name) > -1);
			}

			return event_list;
		}
	},

	created() {
		// this.getLocation();
		this.getCategory();
		var dt = new Date();
		var month = dt.getMonth() - 5,
			year = dt.getFullYear();
		var FirstDay = new Date(year, month, 1);
		var LastDay = new Date(year, 12, 0);
		this.fromDate = moment(new Date()).format("YYYY-MM-DD");
		this.toDate = moment(LastDay).format("YYYY-MM-DD");
		// if (this.eventStartDate && this.eventEndDate) {
		// 	this.fromDate = moment(this.eventStartDate).format("YYYY-MM-DD");
		// 	this.toDate = moment(this.eventEndDate).format("YYYY-MM-DD");
		// }
		this.getEvents();
		this.getUserAccessLevel();


		for (var x=-100; x <= 101; x++){
			if( x % 5 == 0 ) {
				let obj = {};
				obj.title = x+'%';
				obj.value = x;
				this.sales_impact_list.push(obj);
			}
		}
	},

	mounted() {
		if (this.showAddPopup) {
			this.addEventPopup = true;
		} else {
			if (this.eventData && this.eventData.id) {
				setTimeout(() => {
					for (let i in this.categoryList) {
						if (this.eventData.category == this.categoryList[i].id) {
							this.eventData.event_type = this.categoryList[i].type;
						}
					}
					this.editEvent(this.eventData);
				}, 1500);
			}
		}
	},

	methods: {
		selectAllEventCategories(){
			this.selected_categories = [];
			for(let i in this.all_event_category_list){
				this.selected_categories.push(this.all_event_category_list[i].title);
			}
		},

		resetSelectedEventCategories(){
			this.selected_categories = [];
		},

		selectAllEventTypeFilters(){
			this.external_events = true;
			this.internal_events = true;
		},

		resetEventTypeFilters(){
			this.external_events = false;
			this.internal_events = false;
		},

		sortByDescendingDate(){
			// toggled arrows
			this.sort_by_ascending_date = false;
			this.sort_by_descending_date = true;
		},

		sortByAscendingDate(){
			// toggled arrows
			this.sort_by_ascending_date = true;
			this.sort_by_descending_date = false;
		},

		// displayed confirmation box and if confirmed then assigned new value to sales impact otherwise assigned old value
		changeSalesImpact(old_sales_impact, new_sales_impact){
			this.$confirm(`Sales Impact % will adjust your transactions forecast by ${new_sales_impact}% for selected dates`, "Alert", {
			confirmButtonText: "OK",
			cancelButtonText: "Cancel",
			dangerouslyUseHTMLString: true
			})
			.then(() => {
				this.sales_impact = new_sales_impact;

				let percentage = this.sales_impact !=null && this.original_forecast ? (this.original_forecast / 100) * this.sales_impact : null;

				this.updated_forecast = (percentage + this.original_forecast).toFixed();
			})
			.catch(() => {
				this.sales_impact = old_sales_impact;
			});
		},

		getUserAccessLevel() {
			let newLocation = [];
			this.selectStore = "";
			serverAddr
				.get("/users/self/", {})
				.then(res => {
					let user = JSON.parse(res.data);
					this.user = JSON.parse(res.data);
					if (user.access_level == "region") {
					} else if (user.access_level == "sub_region") {
					} else if (user.access_level == "admin") {
						// this.newLocation = this.locations;
					} else {
						this.selectStore = user.access_outlet;
					}
				})
				.catch(err => {
					console.log(err);
				});
		},

		onAddEvent() {
			this.clearFields();
			this.id = "";
			this.addEventPopup = true;
			this.addEventPopupKey += 1;
		},

		closeEventsPageDialog() {
			EventBus.$emit("closeEventsPageDialog", false);
		},

		closePopup() {
			// this.clearFields();
			this.id = "";
			this.locError = "";
			this.selectedLocation = [];
			this.addEventPopup = false;
			this.addEventPopupKey = 0;
			this.update = false;
		},

		onGoClick() {
			this.pageInfo = {
				currentPage: 1,
				count: 0,
				pageSize: 10
			};
			this.getEvents();
		},

		clearCategory() {
			this.category = "";
			console.log(this.category);
		},

		handlePageInfoChange(val) {
			this.pageInfo.currentPage = val;
			console.log("val", val);
			this.getEvents();
		},

		handlePageSizeInfoChange(val) {
			this.pageInfo.pageSize = val;
			console.log("val", val);
		},

		changedDate() {
			this.pageInfo = {
				currentPage: 1,
				count: 0,
				pageSize: 10
			};
			// this.getEvents();
		},

		getLocation() {
			serverAddr
				.get(
					"/outlet/location/?type=store,warehouse,central_kitchen,head_office,distribution_centre,regional_office,vendor"
				)
				.then(response => {
					console.log(JSON.parse(response.data).results);
					let data = JSON.parse(response.data).results;
					for (let i in data) {
						data[i].label = data[i].name;
						data[i].value = data[i].id;
						data[i].children = data[i].regions;
						for (let j in data[i].children) {
							data[i].children[j].label = data[i].children[j].name;
							data[i].children[j].value = data[i].children[j].id;
							data[i].children[j].children = data[i].children[j].subregions;
							for (let k in data[i].children[j].children) {
								data[i].children[j].children[k].label =
									data[i].children[j].children[k].name;
								data[i].children[j].children[k].value =
									data[i].children[j].children[k].id;
								data[i].children[j].children[k].children =
									data[i].children[j].children[k].outlets;
								for (let l in data[i].children[j].children[k].children) {
									data[i].children[j].children[k].children[l].label =
										data[i].children[j].children[k].children[l].name;
									data[i].children[j].children[k].children[l].value =
										data[i].children[j].children[k].children[l].id;
								}
							}
						}
					}
					console.log("newData", data);
					this.options = data;
				});
		},

		handleChange(val) {
			console.log("val", val);
		},

		onDeleteEvent(del, event) {
			if (del === "yes") {
				this.eventToDelete = event;
				this.deleteDialogVisible = true;
			} else {
				this.eventToDelete = {};
				this.deleteDialogVisible = false;
			}
		},

		deleteEvent() {
			if (this.eventToDelete.id) {
				serverAddr
					.delete(`/event/${this.eventToDelete.id}/`)
					.then(response => {
						this.getEvents();
						this.deleteDialogVisible = false;
						EventBus.$emit("eventAdded");
						this.$notify.success({
							title: "Success",
							message: "Event deleted"
						});
					})
					.catch(err => {
						console.log(err);
					});
			}
		},

		editEvent(data) {
			console.log(data);
			this.resetLocationDD += 1;
			if (data.event_type === "Internal") {
				this.event_type = "Internal Event";
			} else this.event_type = "External Event";
			this.addEventPopup = true;
			this.addEventPopupKey += 1;
			this.id = data.id;
			this.start_date = data.start_date;
			this.end_date = data.end_date;
			this.start_time = data.start_time;
			this.end_time = data.end_time;
			this.category = data.category;
			this.description = data.description;
			this.event_title = data.name;
			this.sales_impact = data.impact_sales;
			this.regions = data.regions;
			this.subregions = data.subregions;
			this.countris = data.countries;
			this.outlets = data.stores;
			this.update = true;
			this.id = data.id;
			this.selectedLocation = this.selectedLoc(data);
			this.location_name = data.stores.length
				? data.stores[0].name
				: data.countries.length
				? data.countries[0].name
				: data.regions.length
				? data.regions[0].name
				: data.subregions.length
				? data.subregions[0].name
				: "";

			this.last_updated_by = data.modified_by_full_name;
			this.last_updated_on = data.modified_on ? moment(data.modified_on).format('YYYY-MM-DD') : '';

			// this.getOriginalForecast(data.countries, data.regions, data.subregions, data.stores);
		},

		selectedLoc(data) {
			if(data.stores.length) {
				return data.stores.map(el => {
					return {
						id: el.id,
						name: el.name,
						type: "outlet",
						active: true,
						isSelected: false
					}
				})
			}
			if(data.countries.length) {
				return data.countries.map(el => {
					return {
						id: el.id,
						name: el.name,
						type: "country",
						active: true,
						isSelected: false
					}
				})
			}
			if(data.regions.length) {
				return data.regions.map(el => {
					return {
						id: el.id,
						name: el.name,
						type: "region",
						active: true,
						isSelected: false
					}
				})
			}
			if(data.subregions.length) {
				return data.subregions.map(el => {
					return {
						id: el.id,
						name: el.name,
						type: "subregion",
						active: true,
						isSelected: false
					}
				})
			}
		},

		updatecheckedStoreClosed() {
			var currentDate = moment();
			var weekStart = currentDate.clone().startOf("isoWeek");
			let from_date = moment(weekStart)
				.add(0, "days")
				.format("YYYY-MM-DD");
			let to_date = moment(weekStart)
				.add(6, "days")
				.format("YYYY-MM-DD");
			console.log(from_date, to_date);
			if (this.category == 3) {
				if (
					moment(this.start_date).isBetween(from_date, to_date, undefined, "[]")
				) {
					this.storeClosedVisible = true;
				} else {
					this.storeNextCloseddVisible = true;
				}
			} else {
				this.updateEvent();
			}
		},

		updateEvent() {
			this.event_loading = true;
			let start_date = "";
			let end_date = "";
			start_date = `${moment(this.start_date).format("YYYY-MM-DD")}`;
			end_date = `${moment(this.end_date).format("YYYY-MM-DD")}`;
			// end_date = moment(`${this.end_date} ${this.end_time ? this.end_time : '00:00:00'}`).format("YYYY-MM-DD HH:mm:ss")
			let params = {
				name: this.event_title.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
				end_date: end_date,
				start_date: start_date,
				start_time: "00:00:00",
				end_time: "00:00:00",
				regions: this.regions,
				subregions: this.subregions,
				stores: this.outlets,
				countries: this.countris,
				category: this.category,
				description: this.description,
				impact_sales: this.sales_impact
			};
			serverAddr
				.patch(`/event/${this.id}/`, params)
				.then(response => {
					this.addEventPopup = false;
					EventBus.$emit("eventAdded");
					this.clearFields();
					this.id = "";
					this.update = false;
					this.getEvents();
					this.locError = "";
					this.storeClosedVisible = false;
					this.storeNextCloseddVisible = false;
					this.$notify({
						title: "Success",
						message: "Event Updated Successfully",
						type: "success"
					});
					this.event_loading = false;
				})
				.catch(err => {
					let error = JSON.parse(err.response.data);
					if(error.msg == "Location needed to Edit Event") {
						this.locError = error.msg;
					}
					this.event_loading = false;
					this.$notify({
						title: "Error",
						message: error.msg,
						type: "error"
					});
				});
		},

		getCategory() {
			serverAddr
				.get("/event_category/?get_all=true")
				.then(response => {
					this.categoryList = JSON.parse(response.data);
					this.internal_category = this.categoryList.filter(e => {
						if (e.type == "Internal") {
							return e;
						}
					});
					this.external_category = this.categoryList.filter(e => {
						if (e.type == "External") {
							return e;
						}
					});
				})
				.catch(err => {
					console.log(JSON.parse(err));
				});
		},

		checkedStoreClosed() {
			this.$validator.validateAll().then(result => {
				if (result) {
					var currentDate = moment();
					var weekStart = currentDate.clone().startOf("isoWeek");
					let from_date = moment(weekStart)
						.add(0, "days")
						.format("YYYY-MM-DD");
					let to_date = moment(weekStart)
						.add(6, "days")
						.format("YYYY-MM-DD");
					if (this.category == 3) {
						if (
							moment(this.start_date).isBetween(
								from_date,
								to_date,
								undefined,
								"[]"
							)
						) {
							this.storeClosedVisible = true;
						} else {
							this.storeNextCloseddVisible = true;
						}
					} else {
						this.addEvent();
					}
				}
			});
		},

		addEvent() {
			let start_date = "";
			let end_date = "";
			start_date = `${moment(this.start_date).format("YYYY-MM-DD")}`;
			end_date = `${moment(this.end_date).format("YYYY-MM-DD")}`;
			// end_date = moment(`${this.end_date} ${this.end_time ? this.end_time : '00:00:00'}`).format("YYYY-MM-DD HH:mm:ss")
			let params = {
				name: this.event_title.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
				start_date: start_date,
				end_date: end_date,
				start_time: "00:00:00",
				end_time:  "00:00:00",
				countries: this.countris,
				regions: this.regions,
				subregions: this.subregions,
				stores:
					this.selectStore != ""
						? [{ id: this.selectStore, name: this.user.access_outlet_name }]
						: this.outlets,
				category: this.category,
				description: this.description,
				impact_sales: this.sales_impact
			};
			serverAddr
				.post("/event/", params)
				.then(response => {
					EventBus.$emit("eventAdded");
					this.getEvents();
					this.addEventPopup = false;
					this.clearFields();
					this.radio = true;
					this.storeClosedVisible = false;
					this.storeNextCloseddVisible = false;
					this.locError = "";
					this.$notify({
						title: "Success",
						message: "Event Added Successfully",
						type: "success"
					});
				})
				.catch(err => {
					let error = JSON.parse(err.response.data);
					if(error.msg == "Location need to add Event") {
						this.locError = error.msg;
					}
					this.$notify({
						title: "Error",
						message: error.msg,
						type: "error"
					});
				});
		},

		clearFields() {
			this.resetLocationDD += 1;
			this.start_date = "";
			this.end_date = "";
			this.category = "";
			this.description = "";
			this.event_title = "";
			this.start_time = "";
			this.end_time = "";
			this.id = "";
			this.regions = [];
			this.subregions = [];
			this.outlets = [];
			this.countris = [];
			this.sales_impact = '0';
			// this.location_name = "";
			// this.sales_impact = "";
			this.event_title = "";
			this.update = false;
		},

		async dropdownUpdate(update) {
			this.pageInfo = {
				currentPage: 1,
				pageSize: 10,
				count: 0
			};
			this.newBasics = update.basics;
			this.outlets = [];
			this.countris = [];
			this.regions = [];
			this.subregions = [];
			let selectedLocation = update.selected;
			console.log(update);

			this.outlets = update.map(e => {
				return { id: e };
			});

			// if (update.selected.length) {
			// 	if (update.selected[0].type == "subregion") {
			// 		this.subregions = selectedLocation.map(e => {
			// 			return { id: e.id };
			// 		});
			// 	} else if (update.selected[0].type == "country") {
			// 		this.countris = selectedLocation.map(e => {
			// 			return { id: e.id };
			// 		});
			// 	} else if (update.selected[0].type == "region") {
			// 		this.regions = selectedLocation.map(e => {
			// 			return { id: e.id };
			// 		});
			// 	} else if (update.selected[0].type == "outlet") {
			// 		this.outlets = selectedLocation.map(e => {
			// 			return { id: e.id };
			// 		});
			// 	}
			// }

			this.getOriginalForecast(this.countris, this.regions, this.subregions, this.outlets);
		},

		async getOriginalForecast(countries, regions, subregions, outlets){

			let filters = {
				countries: countries ? countries.map(e => {return e.id}) : this.countris.lenght ? this.countris.map(e => {return e.id}) : [],
				regions: regions ? regions.map(e => {return e.id}) : this.regions.length ? this.regions.map(e => {return e.id}) : [],
				subregions: subregions ? subregions.map(e => {return e.id}) : this.subregions.length ? this.subregions.map(e => {return e.id}) : [],
				outlets: outlets ? outlets.map(e => {return e.id}) : this.outlets.length ? this.outlets.map(e => {return e.id}) : [],
			}

			let params = {
				filters: filters,
				start_date: this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : '',
				end_date: this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : ''
			}

			if(this.start_date && this.end_date){
				let forecat_res = await this.getOriginalForecastNetworkCallBack(params);
				if(forecat_res.status == 200){
					let res = JSON.parse(forecat_res.data);
					console.log(res);
					this.original_forecast = res.original_qty;
					this.updated_forecast = res.adjusted_qty;
				}
			}
		},

		getOriginalForecastNetworkCallBack(params){
			return serverAddr
			.post("/forecast/total_transactions_aggregate/", params)
			.then(response => {
				return response
			})
			.catch(err => {
				console.log(JSON.parse(err));
			});
		},
		// dropdown(update) {
		// 	this.basics = update.basics;
		// 	this.outlet = [];
		// 	this.country = [];
		// 	this.region = [];
		// 	this.subregion = [];
		// 	this.selectedLocation = [update.selected[update.selected.length - 1]];
		// 	console.log(this.selectedLocation);
		// 	if (update.selected.length) {
		// 		if (update.basics == "subregion") {
		// 			this.subregion = this.selectedLocation.map(e => {
		// 				return e.id;
		// 			});
		// 		} else if (update.basics == "country") {
		// 			this.country = this.selectedLocation.map(e => {
		// 				return e.id;
		// 			});
		// 		} else if (update.basics == "region") {
		// 			this.region = this.selectedLocation.map(e => {
		// 				return e.id;
		// 			});
		// 		} else if (update.basics == "outlet") {
		// 			this.outlet = this.selectedLocation.map(e => {
		// 				return e.id;
		// 			});
		// 		}
		// 	}
		// },
		dropdown(update) {
			// console.log("update", update)
			this.fromDate = moment(this.fromDate).format("YYYY-MM-DD");
			this.toDate = moment(this.toDate).format("YYYY-MM-DD");
			this.filters = {
				outlets: update,
				countries: [],
				regions: [],
				subregions: []
			};
			console.log(update);
			// if (update.basics == "subregion") {
			// 	this.filters.subregions = update.selected.map(e => {
			// 		return e.id;
			// 	});
			// } else if (update.basics == "country") {
			// 	this.filters.countries = update.selected.map(e => {
			// 		return e.id;
			// 	});
			// } else if (update.basics == "region") {
			// 	this.filters.regions = update.selected.map(e => {
			// 		return e.id;
			// 	});
			// } else if (update.basics == "outlet") {
			// 	this.filters.outlets = update.selected.map(e => {
			// 		return e.id;
			// 	});
			// }
		},

		getTableData(data, count) {
			for (let i in data) {
				data[i].date = data[i].start_date;
				for (let k in this.categoryList) {
					if (data[i].category == this.categoryList[k].id) {
						data[i].category_name = this.categoryList[k].name;
						data[i].event_type = this.categoryList[k].type;
					}
				}
			}
			this.pageInfo.count = count;
			// console.log(this.count);
			this.events = data;

			console.log("getTableData", this.events);
		},

		getEvents() {
			let params = {
				from_date: moment(this.fromDate).format("YYYY-MM-DD"),
				to_date: moment(this.toDate).format("YYYY-MM-DD"),
				res_type: "simple",
				filters: this.filters
			};
			let events = [];
			let locations = "";
			// if (this.basics == "subregion") {
			// 	params = "subregion";
			// 	locations = this.subregion.toString();
			// } else if (this.basics == "country") {
			// 	params = "country";
			// 	locations = this.country.toString();
			// } else if (this.basics == "region") {
			// 	params = "regions";
			// 	locations = this.region.toString();
			// } else if (this.basics == "outlet") {
			// 	params = "outlet";
			// 	locations = this.outlet.toString();
			// }

			// var queryParams = (queryParams = `?from_date=${this.fromDate}&to_date=${
			// 	this.toDate
			// }&get_all=true`);
			// if (this.basics) {
			// 	queryParams = `?from_date=${this.fromDate}&to_date=${
			// 		this.toDate
			// 	}&${params}=${locations}&get_all=true`;
			// }
			serverAddr
				.post(`/event/list/?get_all=true`, params)
				.then(response => {
					events = JSON.parse(response.data);
					this.getTableData(events, events.count);
				})
				.catch(err => {
					console.log("err", err);
				});
			// this.events = events;
		},

		createCsvJson(events) {
			return events.map(el => {
				console.log(el);
				return {
					DATE: el.start_date == el.end_date ? el.start_date : `${el.start_date} To ${el.end_date}`,
					LOCATION: el.stores.length
						? el.stores.map(e => e.name).toString()
						: el.countries.length
						? el.countries.map(e => e.name).toString()
						: el.regions.length
						? el.regions.map(e => e.name).toString()
						: el.subregions.length
						? el.subregions.map(e => e.name).toString()
						: "",
					EVENT: el.name,
					"EVENT TYPE": el.event_type,
					CATEGORY: el.category_name
				};
			});
		},

		downloadCsvReport(extension) {
			var export_csv = this.createCsvJson(this.events);
			// *****************download csv file************************************
			var csv = Papa.unparse(export_csv);
			console.log(export_csv);
			var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });

			var csvURL = null;
			if (navigator.msSaveBlob) {
				csvURL = navigator.msSaveBlob(csvData, "download.csv");
			} else {
				csvURL = window.URL.createObjectURL(csvData);
			}

			var tempLink = document.createElement("a");
			tempLink.href = csvURL;
			tempLink.setAttribute("download", `EventReport.${extension}`);
			tempLink.click();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./EventsList.scss";
</style>
<style lang="scss">
.EventList  .checkbox-lable .el-checkbox__label{
	font-size: 13px!important;
}
.EventList .el-card {
	overflow: unset;
}
.EventList .el-popover {
	max-width: 350px !important;
}
.EventList .description-textarea {
	width: 100%;
	height: 75px;
	border: 1px solid #dcdfe6;
	resize: none;
	border-radius: 4px;
	outline: none;
}
.EventList .el-dialog {
	/* width: 40%; */
	margin-top: 50px !important;
}
.EventList .el-dialog__header {
	background: #32343d;
}
.EventList .el-dialog__title {
	color: white;
	font-size: 15px;
	/* font-weight: 600; */
}
.EventList .el-input__inner {
	height: 40px;
}
.EventList .el-radio {
	display: flex;
	align-items: center;
	line-height: 1.5;
	margin: 10px 0;
	color: #32343d;
}
</style>
